/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import PasswordSettings from "./PasswordSettings";
import { useCityContext } from "../../../../context/levels/levelsContext";
import { useCompanyContext } from "../../../../context/company/companyContext";
import { useAdminContext } from "../../../../context/admin/context/AdminContext";
import {
  getOneAdmin,
  pushCountry,
} from "../../../../middlewares/sysNavigation/SysNavigation";
import { validateUpdateFields } from "../../../../controllers/admin/adminControllers";
import { useAdminsContext } from "../../../../context/admin/context/AdminManageContext";
import { useCountryContext } from "../../../../context/country/countryContext/CountryContext";
import {
  Title,
  GoBack,
  MyMessage,
  InputField,
  PhoneInput,
  SelectInput,
  MyActionButton,
  SearchSelectInput,
} from "../../component/Component";
import { roles } from "./roles";
import { countriesList } from "../../component/data";

const Edit = () => {
  const { sysAdmin } = useAdminContext();
  const currentRole = sysAdmin?.role;

  const { setCompany } = useCompanyContext();
  const { cities, fetchCities } = useCityContext();
  const { countries, fetchCountries } = useCountryContext();
  const { updateProfile, setAdmins } = useAdminsContext();

  const admin = getOneAdmin();
  const admin_id = admin?.admin_id;

  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const [first_name, setFirstName] = useState(admin?.first_name);
  const [last_name, setLastName] = useState(admin?.last_name);
  const [email, setEmail] = useState(admin?.email);
  const [phone, setPhone] = useState(admin?.phonenumber);
  const [country, setCountry] = useState(admin?.country);
  const [city, setCity] = useState(admin?.city);
  const [address, setAddress] = useState(admin?.address);
  const [role, setRole] = useState(admin?.role);
  const [adminStatus, setAdminStatus] = useState(admin?.active);

  const [password, setPassword] = useState(null);
  const [confirm_password, setConfirmPassword] = useState(null);
  const [action, setAction] = useState("profile");

  const adminRoutes = "/admin";

  useEffect(() => {
    if (!cities) fetchCities(1, 2000);
    if (!countries) fetchCountries();
  }, [cities, countries, country]);

  const responses = (err, msg) => {
    setLoading(false);
    setError(err);
    setSuccess(!err);
    setErrorMessage(msg);
  };

  const updateAdminHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    const { isError, message } = validateUpdateFields(
      first_name,
      last_name,
      email,
      phone,
      address,
      country,
      city
    );
    if (isError) responses(true, message);
    else await sendProfileRequest();
  };

  const sendProfileRequest = async () => {
    const data = {
      email,
      first_name,
      last_name,
      phonenumber: phone,
      country,
      city,
      address,
      role: String(role)?.toLowerCase()?.replaceAll(" ", "_"),
      active: adminStatus,
    };

    const { message, status } = await updateProfile(admin_id, data);
    if (status === 200 || status === 201) {
      setAdmins(null);
      setCompany(null);
      responses(false, message);
    } else {
      responses(true, message);
    }
  };

  const citiesFilter = () => {
    const getId = ({ data, key, value, obj_id }) =>
      data?.find((x) => x?.[key] === value)?.[obj_id] || null;

    const id = getId({
      key: "name",
      value: country,
      data: countries,
      obj_id: "country_id",
    });

    return cities?.filter((x) => x?.country_id === id).map((y) => y?.name);
  };

  return (
    <div className="min-h-full bg-gray-50/70 overflow-y-auto p-4">
      <div className="mx-auto w-full max-w-6xl pb-20">
        <GoBack props={{ route: adminRoutes }} />

        <form onSubmit={updateAdminHandler} className="mt-4 space-y-6">
          <MyMessage
            error={error}
            message={message}
            success={success}
            onExpired={() => {
              setError(false);
              setSuccess(false);
            }}
            onClick={() => {
              setError(false);
              setSuccess(false);
              setErrorMessage("");
            }}
          />

          <div className="rounded-2xl border border-gray-200 bg-white shadow-sm">
            <div className="h-1.5 rounded-t-2xl bg-gradient-to-r from-emerald-500 via-amber-500 to-fuchsia-500" />
            <div className="p-5">
              <div className="mb-2">
                <Title props={{ title: "Update Admin Profile" }} />
                <p className="mt-1 text-xs text-gray-600">
                  Update personal info, location, and access settings.
                </p>
              </div>

              <div className="grid grid-cols-1 gap-5">
                <section className="rounded-xl border border-gray-100 bg-white p-4">
                  <h3 className="text-sm font-semibold tracking-tight text-gray-900">
                    Basic Information
                  </h3>
                  <p className="mt-0.5 text-xs text-gray-600">
                    Your public profile details.
                  </p>
                  <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
                    <InputField
                      props={{
                        id: "firstname",
                        title: "First Name",
                        type: "text",
                        value: first_name || "",
                        onChange: (e) => {
                          setFirstName(e.target.value);
                          setError(null);
                          setSuccess(null);
                        },
                      }}
                    />
                    <InputField
                      props={{
                        id: "lastname",
                        title: "Last Name",
                        type: "text",
                        value: last_name || "",
                        onChange: (e) => {
                          setLastName(e.target.value);
                          setError(null);
                          setSuccess(null);
                        },
                      }}
                    />
                    <InputField
                      props={{
                        id: "email",
                        title: "Email Address",
                        type: "email",
                        value: email || "",
                        onChange: (e) => {
                          setEmail(e.target.value);
                          setError(null);
                          setSuccess(null);
                        },
                      }}
                    />
                    <div className="w-full">
                      <PhoneInput
                        setPhone={setPhone}
                        phone={phone}
                        required={true}
                        country={country || ""}
                      />
                    </div>
                  </div>
                </section>

                <section className="rounded-xl border border-gray-100 bg-white p-4">
                  <h3 className="text-sm font-semibold tracking-tight text-gray-900">
                    Location
                  </h3>
                  <p className="mt-0.5 text-xs text-gray-600">
                    Where you are currently based.
                  </p>
                  <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
                    <SearchSelectInput
                      title="Country"
                      value={country || null}
                      options={countries ? countries?.map((x) => x?.name) : []}
                      onChange={(country) => {
                        setCountry(country);
                        const pickedCountry = countriesList?.find(
                          (_c) => _c.name === country
                        );
                        pushCountry({
                          country: {
                            id: pickedCountry?.id,
                            name: pickedCountry?.name,
                            slug: pickedCountry?.name,
                            route: "/admin",
                          },
                        });
                        setCity(null);
                      }}
                    />
                    <SearchSelectInput
                      title="City"
                      setValue={setCity}
                      value={city || null}
                      options={
                        cities
                          ? country && !city
                            ? citiesFilter()
                            : cities?.map((x) => x?.name)
                          : []
                      }
                      onChange={(city) => setCity(city)}
                    />
                    <InputField
                      props={{
                        id: "address",
                        title: "Address",
                        type: "text",
                        value: address || "",
                        onChange: (e) => {
                          setAddress(e.target.value);
                          setError(null);
                          setSuccess(null);
                        },
                      }}
                    />
                  </div>
                </section>

                <section className="rounded-xl border border-gray-100 bg-white p-4">
                  <h3 className="text-sm font-semibold tracking-tight text-gray-900">
                    Access & Status
                  </h3>
                  <p className="mt-0.5 text-xs text-gray-600">
                    Control the admin privileges and account state.
                  </p>
                  <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
                    <SelectInput
                      title="Admin Status"
                      options={["unblocked", "blocked"]}
                      defaultValue={adminStatus === 1 ? "unblocked" : "blocked"}
                      onChange={(e) => {
                        setAdminStatus(e.target.value === "unblocked" ? 1 : 0);
                        setError(null);
                        setSuccess(null);
                      }}
                    />
                    <SelectInput
                      title="Admin Role"
                      defaultValue={
                        role
                          ? String(role)?.toLowerCase()?.replaceAll("_", " ")
                          : "content_creator"
                      }
                      options={roles(currentRole)}
                      onChange={(e) => {
                        setRole(e.target.value);
                        setError(null);
                        setSuccess(null);
                      }}
                    />
                  </div>
                </section>
              </div>
            </div>

            <div className="border-t border-gray-100 bg-white px-5 py-4 rounded-b-2xl">
              <div className="flex items-center justify-end">
                <MyActionButton
                  title="Update Profile"
                  loading={action === "profile" ? loading : false}
                  onClick={() => {
                    setAction("profile");
                    setError(false);
                    setSuccess(false);
                    setErrorMessage(null);
                  }}
                />
              </div>
            </div>
          </div>
        </form>

        <div className="mt-6 rounded-2xl border border-gray-200 bg-white shadow-sm">
          <div className="h-1.5 rounded-t-2xl bg-gradient-to-r from-sky-500 via-indigo-500 to-fuchsia-500" />
          <div className="p-5">
            <Title props={{ title: "Password & Security" }} />
            <p className="mt-1 mb-4 text-xs text-gray-600">
              Update your password regularly to keep your account secure.
            </p>
            <PasswordSettings
              password={password}
              setError={setError}
              setAction={setAction}
              responses={responses}
              setSuccess={setSuccess}
              setLoading={setLoading}
              setPassword={setPassword}
              setErrorMessage={setErrorMessage}
              confirm_password={confirm_password}
              setConfirmPassword={setConfirmPassword}
              loading={action === "password" ? loading : false}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Edit;
